import React, {MutableRefObject, useEffect, useRef, useState} from 'react';
import { observer } from 'mobx-react-lite';
import {useAppStateContext} from 'src/AppState/AppState';
import { ColumnWrapper, BasicMarketItemWrapper, BasicMarketItemSelectFilter, MarketName, ActionButton, FiltersButton, FilterElem, ColumnHeader, ButtonWrapper } from 'src/components/SportPopup/MarketFilters/MarketFilters.style';
import { MarketFiltersState, MarketFromEvents } from 'src/AppState/MarketFiltersState/MarketFiltersState';
import { MarketFilterType } from 'src/api/config/marketFilters/getMarketFiltersForSport';
import Icon from 'src/components/Icon/Icon';
import { BasicFilterItemState, BasicMarketItemState } from './AllMarkets.state';
import { MarketType } from 'src/api/config/marketFilters/getMarketsForSport';
import { PlusCircleIcon } from 'src/assets/icons/PlusCircleIcon';

interface BasicFilterItemPropsType {
    filter: MarketFilterType
    market: MarketFromEvents
    marketFiltersState: MarketFiltersState
    isSelectedInCustomFilter: (filterId: number) => MarketType | null
}

const BasicFilterItem = observer(({filter, isSelectedInCustomFilter, market, marketFiltersState}: BasicFilterItemPropsType) => {
    const [state] = useState(() => new BasicFilterItemState(filter.id, isSelectedInCustomFilter, marketFiltersState, market));

    return (
        <FilterElem isSelected={state.isChecked} key={filter.filter_slug}>
            <div>{filter.filter_name}</div>
            <input type='checkbox' checked={state.isChecked} onChange={state.toggleMarketHandler}/>
        </FilterElem>
    );
});

interface BasicMarketItemPropsTypes {
    market: MarketFromEvents
    marketFiltersState: MarketFiltersState
}

export const BasicMarketItem = observer(({ market, marketFiltersState }: BasicMarketItemPropsTypes) => {
    const [state] = useState( () => new BasicMarketItemState(market, marketFiltersState));
    const dropdownRef = useRef(null);
    useClickOutside(dropdownRef, state.toggleSelect);

    const { getFiltersForSport, selectedFilter } = marketFiltersState;
    const isAddToFilterButtonVisible = state.isSelectedInCurrentFilter === false && selectedFilter !== null && selectedFilter.filter_slug !== 'all_markets';

    return (
        <BasicMarketItemWrapper>
            <ButtonWrapper>
                {isAddToFilterButtonVisible && state.isLoading === false ?
                    <ActionButton onClick={state.addMarketHandler}> <PlusCircleIcon /> </ActionButton> :
                    null}
            </ButtonWrapper>
            <MarketName isSelected={state.isSelectedInCurrentFilter}>{market.market_name}</MarketName>
            <FiltersButton onClick={state.toggleSelect}>
                <div>
                    <Icon name='arrowDown'/>
                </div>
            </FiltersButton>
            { state.isOpenFiltersSelect ? (
                <BasicMarketItemSelectFilter ref={dropdownRef}>
                    {getFiltersForSport.map(filter => filter.filter_slug !== 'all_markets' ? <BasicFilterItem key={filter.filter_slug} filter={filter} market={market} isSelectedInCustomFilter={state.isSelectedInCustomFilter} marketFiltersState={marketFiltersState} /> : null)}
                </BasicMarketItemSelectFilter>
            ) : null}
        </BasicMarketItemWrapper>
    );
});

interface AllMarketsPropsType {
    sportName: string
}
export const AllMarkets = observer(({sportName}: AllMarketsPropsType) => {

    const { marketFiltersState } = useAppStateContext();
    const marketFilterStateBySport = marketFiltersState.get(sportName);
    const { allMarketFromEvents } = marketFilterStateBySport;

    return (
        <ColumnWrapper>
            <ColumnHeader>All markets:</ColumnHeader>
            <div>
                {allMarketFromEvents.map((marketFromEvent, index) => {
                    return (
                        <BasicMarketItem key={`${marketFromEvent.market_id}-${index}`}  market={marketFromEvent} marketFiltersState={marketFilterStateBySport}/>
                    );
                })}
            </div>
        </ColumnWrapper>
    );
});


const useClickOutside = (ref: MutableRefObject<unknown>, onClickOutsideCallback: () => void): void => {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            // @ts-expect-error
            if (ref.current && !ref.current.contains(event.target) ) {
                onClickOutsideCallback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};
